import { photoUrl, siteUrl } from "../config";

export const placemarkHotelPopup = (hotel) => {
  return `
    <div class="ymHotelWrap" onclick="window.open('${siteUrl}${hotel.url}', '_blank')" ${
      hotel.photos?.length > 0
        ? `style="background: url('${photoUrl}/${hotel.photo_url}/hotel/${hotel.photos[0]}.jpg'); background-size: cover;"`
        : ""
    }>
      <div class="ymHotelHeader">
        <div class="ymHotelInfo">
            <div class="ymHotelTemplate">${hotel.template || ""} <span class="ymHotelStars">${
              hotel?.star_rating
                ? `<svg 
            width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.5 0L6.73483 3.80041H10.7308L7.49799 6.14919L8.73282 9.94959L5.5 7.60081L2.26718 9.94959L3.50201 6.14919L0.269189 3.80041H4.26517L5.5 0Z" fill="#E3AB32"/></svg>`.repeat(
                    hotel.star_rating,
                  )
                : ""
            }</span></div>
            <div class="ymHotelTitle">${hotel?.name || "#" + hotel.id}</div>
        </div>
        ${
          hotel?.meta_rating > 0
            ? `<div class="ymHotelRating">
                <div class="ratingWrap">
                  <svg
                    width="46"
                    height="43"
                    viewBox="0 0 46 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M20.4234 1.40927C21.9711 0.32841 24.0289 0.328411 25.5766 1.40927L34.2737 7.48312L42.7378 13.8776C44.244 15.0156 44.8799 16.9726 44.3302 18.7785L41.2412 28.927L37.7752 38.9528C37.1584 40.7369 35.4936 41.9465 33.6062 41.9817L23 42.1799L12.3938 41.9817C10.5064 41.9465 8.84159 40.7369 8.22481 38.9528L4.75882 28.9269L1.6698 18.7785C1.1201 16.9726 1.75598 15.0156 3.2622 13.8776L11.7263 7.48312L20.4234 1.40927Z"
                      fill='#6FAA37'/>
                  </svg>
                  <span class="pentagon">${hotel.meta_rating}</span>
                </div>
              </div>`
            : ""
        }
      </div>
      <div class="ymHotelFooter">
        <div class="ymHotelFooterInfo">
            <div class="ymHotelAddress">${hotel.address || ""}</div>
            <div class="ymHotelServices">
                ${hotel?.popular_services?.map((service) => `<span>${service}</span>`).join(" - ") || ""}
            </div>
        </div>
        <div class="ymHotelPriceWrap">${hotel?.min_price > 0 ? `<span class="ymHotelPrice">от ${hotel.min_price}Р</span>` : ""}</div>
      </div>
    </div>`;
};

// стили для всплывающих карточек
export const placemarkStyles = `
  .ymHotelWrap {
    cursor: pointer;
    border-radius: 12px;
    overflow: hidden;
    min-width: 280px;
    max-width: 350px;
    background-color: #f8f9fa;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  }
  .ymHotelHeader {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    padding: 16px;
    background: rgba(255,255,255,0.9);
  }
  .ymHotelInfo {
    flex: 1;
    min-width: 0; /* Важно для переноса текста */
  }
  .ymHotelTemplate {
    font-size: 13px;
    color: #666;
    margin-bottom: 4px;
  }
  .ymHotelTitle {
    font-weight: 600;
    font-size: 16px;
    color: #1a1a1a;
    margin-top: 4px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }
  .ymHotelStars {
    margin-left: 4px;
  }
  .ymHotelRating {
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }
  .ymHotelFooter {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 12px;
    padding: 12px 16px;
    background: rgba(255,255,255,0.9);
  }
  .ymHotelFooterInfo {
    flex: 1;
    min-width: 0;
  }
  .ymHotelAddress {
    font-size: 13px;
    color: #666;
    margin-bottom: 4px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .ymHotelServices {
    font-size: 12px;
    color: #999;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .ymHotelPriceWrap {
    flex-shrink: 0;
  }
  .ymHotelPrice {
    font-weight: 600;
    font-size: 16px;
    color: #2b6cc4;
    white-space: nowrap;
  }
  .ratingWrap {
    position: relative;
    display: inline-block;
    width: 46px;
    height: 43px;
  }
  .ratingWrap svg {
    display: block;
  }
  .pentagon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-weight: bold;
    font-size: 14px;
    line-height: 1;
    z-index: 1;
  }
`;
